module.exports = __webpack_public_path__ + "media/application/images/demo/top2-97fc63b21e6dbddd04dbc20e282f640b.jpg";